import { isSupplyType } from "src/util/allocations";
import { getGroupType } from "src/util/groupType";

type TeamLike = {
  type?: string | null;
  isHidden?: boolean | null;
  isDeleted?: boolean | null;
} | null;

type GroupTypes = Record<string, unknown> | null | undefined;

type IsTeamInsightsAvailableArgs = {
  /** Workspace `enableOrgDesign` — release OD Insights UI gate. */
  insightsEnabled: boolean;
  team?: TeamLike | undefined;
  groupTypes?: GroupTypes;
};

export const isTeamInsightsAvailableForTeam = ({
  insightsEnabled,
  team,
  groupTypes,
}: IsTeamInsightsAvailableArgs): boolean => {
  if (!insightsEnabled || !team?.type) {
    return false;
  }
  if (team.isHidden || team.isDeleted) {
    return false;
  }
  // Demand teams remain excluded until their ownership semantics are defined.
  return isSupplyType(getGroupType(team, groupTypes));
};
